import { useState } from 'react';

export default function() {
  const [show, setShow] = useState(false);
  return [show, setShow];
}
